import { useEffect, useState } from "react";

/** `active`, but only once it has held for `delayMs`: whatever ends sooner never shows. */
export const useAfterDelay = (active: boolean, delayMs: number): boolean => {
	const [elapsed, setElapsed] = useState(false);

	useEffect(() => {
		if (!active) {
			setElapsed(false);
			return;
		}
		const timer = setTimeout(() => setElapsed(true), delayMs);
		return () => clearTimeout(timer);
	}, [active, delayMs]);

	return active && (delayMs === 0 || elapsed);
};
